import React from "react";
import styles from "./cardSection.module.css";
import { Container } from "react-bootstrap";
import { Heading, Paragraph } from "../TextComponents/TextComponents";

const CardSection = () => {
  const userInfo = [
    {
      id: 1,
      name: "Meena Neupane – Founder & CEO",
      description:
        "With over a decade of experience in global trade and commodity markets, Meena Neupane is the driving force behind CrossBorder BTC. Her visionary leadership has spearheaded the company’s growth from a single-vertical enterprise to a global powerhouse operating in five countries.",
      Image: "/images/AboutImage/about_img/user_1.png",
    },
    {
      id: 2,
      name: "Varun Kant – Vice President, Business Development",
      description:
        "With a knack for identifying market opportunities, Varun leads our efforts in forging impactful partnerships and driving revenue growth.",
      Image: "/images/AboutImage/about_img/user_2.png",
    },
    {
      id: 3,
      name: "Prerna Batheja – Vice President, Human Resources",
      description:
        "Prerna ensures CrossBorder BTC remains a people-first organization. She fosters a culture of collaboration, innovation, and growth, ensuring our team thrives in a supportive environment.",
      Image: "/images/AboutImage/about_img/user_3.png",
    },
    {
      id: 4,
      name: "Abhishek Singh – Vice President, IT",
      description:
        "An innovator at heart, Abhishek drives the technological backbone of CrossBorder BTC. His focus on digital transformation ensures seamless operations and cutting-edge solutions for clients.",
      Image: "/images/AboutImage/about_img/user_4.png",
    },
    {
      id: 5,
      name: "Lalit Wadhwa – Chief Financial Officer (CFO)",
      description:
        "Lalit brings over 15 years of financial expertise to CrossBorder BTC. His strategic financial planning and resource management ensure the company’s sustainable growth and profitability.",
      Image: "/images/AboutImage/about_img/user_5.png",
    },
    {
      id: 6,
      name: "Victor Jonas – Chief Legal Officer (CLO)",
      description:
        "An expert in international trade law, Victor ensures that all operations align with regulatory standards and compliance requirements..",
      Image: "/images/AboutImage/about_img/user_6.png",
    },
  ];
  return (
    <React.Fragment>
      <Container>
        <div className={styles.mainSection}>
          <Heading>
            The Visionaries Behind CrossBorder <br /> BTC
          </Heading>
          <Paragraph color="#62677A">
            Driven by passion, guided by expertise, and united by a vision to
            empower global <br /> trade.
          </Paragraph>
        </div>

        <div className={styles.userGrid}>
          {userInfo.map((user) => (
            <div key={user.id} className={styles.userCard}>
              {" "}
              <img
                loading="lazy"
                src={user.Image}
                alt={user.name}
                className={styles.userImage}
              />
              <h3 className={styles.userName}>{user.name}</h3>{" "}
              <p className={styles.userDescription}>{user.description}</p>{" "}
            </div>
          ))}
        </div>
      </Container>
    </React.Fragment>
  );
};

export default CardSection;
